import { Stack, Typography } from '@mui/material';
import LightningIcon from 'assets/images/icons/lightning-gray.svg';

export default function ShippingIcon({ shipping }) {
	if (shipping === 'fulfillment') {
		return (
			<Stack direction="row" alignItems="center">
				<img src={LightningIcon} alt="full" />{' '}
				<Typography
					sx={{
						color: '#545454',
						fontSize: '9px',
						fontWeight: '700',
						fontFamily: 'Inter',
						fontStyle: 'italic',
						lineHeight: 'normal',
					}}
				>
					FULL
				</Typography>
			</Stack>
		);
	}

	return (
		<Typography
			sx={{
				color: '#545454',
				fontSize: '9px',
				fontWeight: '700',
				fontFamily: 'Inter',
				fontStyle: 'italic',
				lineHeight: 'normal',
			}}
		>
			FLEX
		</Typography>
	);
}
